import React from 'react';
import { CargoOperationViewModel } from 'src/types/ViewModel/Stowage/CargoOperation/CargoOperationViewModel';
import { DefaultWrapper, PanelSectionContent, PanelSubHeader } from 'src/components/ui/odfjellPanel/OdfjellPanel.styles';
import OdfjellInputComponent from 'src/components/common/odfjell-input-component/OdfjellInputComponent';
import { InputChangeData } from 'src/components/common/odfjell-input-component/OdfjellInputComponent';

interface CommentsSectionProps {
    cargoOperationVM: CargoOperationViewModel;
    isFieldReadOnly: (field: string) => boolean;
    onCargoInputChange: (changeObject: InputChangeData) => void;
}

export const CommentsSection: React.FC<CommentsSectionProps> = ({ cargoOperationVM, isFieldReadOnly, onCargoInputChange }) => {
    return (
        <PanelSectionContent>
            <PanelSubHeader>Comments</PanelSubHeader>
            <DefaultWrapper className="highlight-panel" noMargin>
                <OdfjellInputComponent
                    isReadOnly={isFieldReadOnly('comment')}
                    type={'textarea'}
                    value={cargoOperationVM.cargo.comment}
                    name={'comment'}
                    dataObject={cargoOperationVM.cargo}
                    leaveBlank={true}
                    onChange={onCargoInputChange}
                    tabIndex={18}
                    disableUnit={true}
                />
            </DefaultWrapper>
        </PanelSectionContent>
    );
};
